import React, { useState } from "react"
import { ModalPopUp } from "./ModalPopUp"
import localSliderImg2 from "../../../../assets/image/1s.png";
import localSliderImg3 from "../../../../assets/image/2s.png";
import localSliderImg1 from "../../../../assets/image/3s.png";

export default function YTvideo() {

    const [activeVideoUrl, setActiveVideoUrl] = useState(null);


    const openModalWithVideo = (url) => {
        setActiveVideoUrl(url);
    };


    const closeModal = () => {
        setActiveVideoUrl(null);
    };
    const videos = [
        { id: 1, title: 'Rossi Clothiers', imageUrl: localSliderImg1, embedUrl: 'https://www.youtube.com/embed/O124eOK7zOE?si=vpNDij2cDWjYUZUG' },
        { id: 2, title: 'Avoli Osteria', imageUrl: localSliderImg2, embedUrl: 'https://www.youtube.com/embed/ONbZ7v4YWEg?si=jvqBMi3V422XsCnu' },
        { id: 3, title: 'Hammer and Nails', imageUrl: localSliderImg3, embedUrl: 'https://www.youtube.com/embed/GI-ByOtbqLw?si=RwzQWbI-z5Prq8O2' },
    ];
    const isModalOpen = !!activeVideoUrl;
    return (
        <>
            {/* video section start */}
            <div className="container">
                <div className="sub-heading-white mt-5">
                    <span className="every-text"> Every </span> Story Shared.
                </div>
                <div className="sub-heading-white mb-3">
                    <span className="every-text"> Every </span> Business Supported.
                    <span className="every-text"> Every </span> Connection Made.
                </div>
                <div className="sub-content">
                    Together, we're building something stronger — and it starts right
                    here, with you.
                </div>
                <div className="slider-container second-slider container p-0">
                    <div className="row">
                        {videos.map((video) => (
                            <div className="col-12 col-md-6 col-lg-4" key={video.id}>
                                <div className="text-center">
                                    <div
                                        className="slider-img-container cursor-pointer"
                                        onClick={() => openModalWithVideo(video.embedUrl)}
                                    >
                                        <i className="fa-solid fa-play play-btn"></i>
                                        <img src={video.imageUrl} alt={video.title} />
                                        <p className="image-content">{video.title}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>


                    <ModalPopUp
                        isOpen={isModalOpen}
                        onClose={closeModal}
                    >

                        {activeVideoUrl && (
                            <iframe
                                width="560"
                                height="315"
                                src={activeVideoUrl}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        )}
                    </ModalPopUp>
                </div>
            </div>
            {/* video section end */}

        </>
    )
}